module.exports = __webpack_public_path__ + "media/images/redesign-images/about-us/ig/ig-02-a9ff919e8a90a705ce2c410e17b98394.jpg";